import React, { useContext, useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Card,
  Table,
} from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { GlobalContext } from "../Context/GlobalState";
import { MdContentPaste } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import key1 from "../Images/key1.svg";
import pay from "../Images/pay.png";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
import { FaArrowRight } from "react-icons/fa";
import TestimonialPage from "./Testonomialraghar";
import SideTab from "./Toolstab";
import { basicauth } from "../Utils/Credentials";
import { Helmet } from "react-helmet";
const Humanizer = () => {
  const resultRef = useRef(null);

  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const resultsRef = useRef(null); 
  const [results, setResults] = useState([]);
  const { setTransactionLoaderState } = useContext(GlobalContext);

  const handleAnalyze = async () => {
    setTransactionLoaderState(true);
    setError(null);
    setLoading(true);
    setResults([]);

    if (!content.trim()) {
      setError("Please paste some content before analyzing.");
      setTransactionLoaderState(false);
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/ContentAnalysis/humanize`,
        {
          method: "POST",
          headers: {
            "Authorization": `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ text: content }),
        }
      );

      const data = await response.json();
      const alternatives = data?.alternatives || [];

      if (alternatives.length === 0) {
        setError("No humanized alternatives returned.");
        return;
      }

      setResults(alternatives);
    } catch (err) {
      console.error("API Error:", err);
      setError("An error occurred while analyzing the content.");
    }

    setTransactionLoaderState(false);
    setLoading(false);
  };
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Bix Humanizer – Instantly Make AI Text Sound Human",
    url: "https://seobix.com/bix-humanizer",
    description:
      "Bix Humanizer converts AI-written text into authentic, natural language that passes all AI detectors. Perfect for blogs, SEO, and social media posts.",
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Bix Humanizer",
          item: "https://seobix.com/bix-humanizer",
        },
      ],
    },
    mainEntity: {
      "@type": "SoftwareApplication",
      name: "Bix Humanizer",
      applicationCategory: "SEO Tool",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free SEO Tool",
      },
    },
    inLanguage: "en",
    keywords: [
      "Best Ai humanizer tool",
      "Ai writing tool",
      "Ai humanizer",
      "Humanize ai",
      "Ai writing humanizer",
      "humanizer tool",
      "ai humanizer tool",
      "humaniser tool",
      "humanise social media",
      "How to Humanise",
      "How to Humanize",
      "Best Ai humaniser tool",
    ],
    mainEntityOfPage: [
      {
        "@type": "Question",
        name: "What is Bix Humanizer?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Bix Humanizer is a tool that converts AI-generated text into authentic, natural language that passes AI detectors, making it perfect for blogs, SEO, and social media posts.",
        },
      },
      {
        "@type": "Question",
        name: "How does Bix Humanizer work?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Bix Humanizer analyzes AI-written text and rewrites it in a human-like tone, ensuring it reads naturally and avoids AI detection.",
        },
      },
      {
        "@type": "Question",
        name: "Is Bix Humanizer free to use?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, Bix Humanizer is free to use and helps improve content quality, SEO performance, and readability for all types of text.",
        },
      },
    ],
  };

  return (
    <Container fluid className="p-0" style={{ overflowX: "clip" }}>
      <Helmet>
        <title>Bix Humanizer – Instantly Make AI Text Sound Human</title>
        <meta
          name="description"
          content="Bix Humanizer converts AI-written text into authentic, natural language that passes all AI detectors. Perfect for blogs, SEO, and social media posts."
        />
        <meta
          name="keywords"
          content="Best Ai humanizer tool, Ai writing tool, Ai humanizer, Humanize ai, Ai writing humanizer, humanizer tool, ai humanizer tool, humaniser tool, humanise social media, How to Humanise, How to Humanize, Best Ai humaniser tool"
        />
        <link rel="canonical" href="https://seobix.com/bix-humanizer" />

        <meta
          property="og:title"
          content="Bix Humanizer – Instantly Make AI Text Sound Human"
        />
        <meta
          property="og:description"
          content="Bix Humanizer converts AI-written text into authentic, natural language that passes all AI detectors. Perfect for blogs, SEO, and social media posts."
        />
        <meta property="og:url" content="https://seobix.com/bix-humanizer" />
        <meta property="og:site_name" content="Seobix" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="600" />
        <meta property="og:locale" content="en_US" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Bix Humanizer – Instantly Make AI Text Sound Human"
        />
        <meta
          name="twitter:description"
          content="Bix Humanizer converts AI-written text into authentic, natural language that passes all AI detectors. Perfect for blogs, SEO, and social media posts."
        />
        <meta
          name="twitter:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta name="twitter:site" content="@seobix" />
        <meta name="twitter:creator" content="@seobix" />

        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
      </Helmet>
      <div>
        <Nav />
      </div>
      <Row className="d-flex justify-content-center mb-5">
        <Col md={10} className="mt-4">
          <h1 className="mb-3 text-center">
            <b>Bix Humanizer</b>
          </h1>

          <Form>
            <Form.Group
              className="mb-3"
              controlId="contentTextarea"
              style={{ position: "relative" }}
            >
              <MdContentPaste
                style={{
                  position: "absolute",
                  top: "18px",
                  left: "20px",
                  fontSize: "1.5rem",
                  color: "#ccc",
                  pointerEvents: "none",
                  zIndex: "1",
                }}
              />
              <Form.Control
                as="textarea"
                rows={12}
                placeholder="Paste your content here..."
                value={content}
                onChange={(e) => setContent(e.target.value)}
                style={{
                  fontSize: "1rem",
                  padding: "1.25rem 1.25rem 1.25rem 3rem",
                  border: "1px solid #ccc",
                  borderRadius: "12px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                  transition: "box-shadow 0.3s ease-in-out",
                  resize: "vertical",
                  minHeight: "250px",
                }}
              />
            </Form.Group>
            <Button
              variant="primary"
              onClick={handleAnalyze}
              disabled={loading}
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Humanize"}
            </Button>
          </Form>

          {error && (
            <Alert variant="danger" className="mt-3">
              {error}
            </Alert>
          )}
       {results.length > 0 && (
            <div ref={resultsRef} style={{ marginTop: "1.5rem" }}>
              <h5><b>Humanized Alternatives:</b></h5>
              {results.map((alt, index) => (
                <div
                  key={index}
                  style={{
                    marginTop: "1rem",
                    padding: "1.5rem",
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    whiteSpace: "pre-line",
                    fontSize: "1rem",
                    lineHeight: "1.6",
                  }}
                >
                  <b>Version {index + 1}</b>
                  <br />
                  {alt}
                </div>
              ))}
            </div>
          )}
          <Row className="justify-content-between">
            <Col md={8}>
              <Content />
            </Col>

            <Col md={3}>
              <div
                className="mb-5"
                style={{
                  position: "sticky",
                  top: "20px",
                  zIndex: 10,
                  background: "#f8f9fa",
                  padding: "1rem",
                  borderRadius: "10px",
                }}
              >
                <h5
                  className="text-center mb-4"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.3rem",
                    color: "#fff",
                    backgroundColor: "#799EFF",
                    display: "inline-block",
                    padding: "6px 16px",
                    borderRadius: "0.5rem",
                  }}
                >
                  🚀 Explore More SEO Tools
                </h5>
                <SideTab />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};
const Content = () => {
  const [showMore, setShowMore] = useState(false);
  return (
    <div className="">
      <h2 className=" mt-md-4">
        Free AI Text Humanizer by SeoBix – Instantly Humanize Any AI Content
      </h2>

      <p className=" mt-2">
        AI-generated content is everywhere. But sounding robotic? That’s a
        problem. If you want your writing to feel real, you need more than just
        AI. You need SeoBix’s AI Humanizer Tool.
      </p>
      <p className=" mt-2">
        With just one click, SeoBix helps you humanize AI text and make it
        completely natural. Whether it’s for blogs, essays, product
        descriptions, or emails, SeoBix makes your content sound like it is
        written by a human, not by a bot.
      </p>
      <h3>What Is the SEOBix AI Humanizer Tool?</h3>
      <div style={{ position: "relative" }}>
        <p>
          The AI humanizer tool by SeoBix rewrites AI content in a way that
          sounds fully human. It changes sentence structure, adjusts tone, and
          adds a natural flow, while keeping your original message.
        </p>

        {!showMore && (
          <div
            style={{
              position: "absolute",
              bottom: "0.5rem",
              left: 0,
              right: 0,
              height: "2.5em",
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
            }}
          />
        )}
      </div>
      <div className="d-flex justify-content-center">
        {!showMore && (
          <Button
            onClick={() => setShowMore(true)}
            style={{
              padding: "6px 20px",
              backgroundColor: "#fff",
              color: "#0d6efd",
              fontWeight: "600",
              fontSize: "0.95rem",
              border: "2px solid #0d6efd",
              borderRadius: "999px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0d6efd";
              e.target.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#0d6efd";
            }}
          >
            Read More
          </Button>
        )}
      </div>

      {showMore && (
        <>
          <p>
            The most important thing, it helps you beat detection tools. That
            means your content not only sounds better but also passes major AI
            detectors and humanizer checks.
          </p>

          <h2>Why Choose SeoBix to Humanize Your AI Text?</h2>
          <ul>
            <li>Free AI Text Humanizer – No payment. No sign-up. 100% free.</li>
            <li>
              Undetectable AI Rewriting – SeoBix helps you bypass AI checkers
              like GPTZero and Turnitin.
            </li>
            <li>Fast and easy – Just paste your text and click. That’s it.</li>
            <li>
              Safe and private – SeoBix doesn’t save your content. Everything is
              processed instantly.
            </li>
          </ul>

          <p>
            Doesn’t matter whether you are a student, blogger, content writer,
            or marketer, SeoBix is built for anyone who wants to sound more
            human online.
          </p>

          <h2>Beat AI Detectors with SeoBix</h2>
          <p>
            AI checkers are getting smarter. Tools like GPTZero, Turnitin, and
            Originality.ai can catch typical AI writing fast. But SeoBix’s
            undetectable AI humanizer rewrites your text so it sounds completely
            natural, and harder to flag.
          </p>
          <p>
            So if you want to stay ahead, use SeoBix as your go-to AI detector
            and humanizer solution.
          </p>

          <h2>Who Should Use SeoBix?</h2>
          <p>
            SeoBix’s AI humanizer tool is for anyone who wants their content to
            sound more natural and avoid AI detection:
          </p>
          <ul>
            <li>
              <strong>Students</strong> – It helps them to rewrite essays and
              projects that pass Turnitin
            </li>
            <li>
              <strong>Bloggers & writers</strong> – Make your AI drafts sound
              more like you
            </li>
            <li>
              <strong>SEO professionals</strong> – Craft content that helps them
              get their content ranked
            </li>
            <li>
              <strong>Freelancers</strong> – It helps them to deliver clean,
              readable content to clients
            </li>
          </ul>
          <p>
            No matter what you write, SeoBix helps you sound more like a human
            and less like a machine.
          </p>

          <h2>Why is SeoBix one of the best AI Text Humanizer?</h2>
          <p>
            A lot of AI Text Humanizer tools are out there, but here's why
            SeoBix stands out:
          </p>
          <ul>
            <li>
              <strong>One-click simplicity</strong> – Just paste and convert to
              humanized content
            </li>
            <li>
              <strong>Optimized for all content types</strong> – For essays to
              web copies
            </li>
            <li>
              <strong>Undetectable AI</strong> – SeoBix stays ahead of detection
              AI tools
            </li>
          </ul>
          <p>
            Whether you need a free AI text humanizer or an AI humanizer tool
            that delivers quality every time, SeoBix is the smart choice.
          </p>

          <h2>Check The Quality Of the Content</h2>
          <p>
            If you want to check the quality of your content, use SeoBix’s
            content analyzer. You just have to paste your content, and it will
            show:
          </p>
          <ul>
            <li>AI Words</li>
            <li>Plagiarism</li>
            <li>Human</li>
            <li>Word Count</li>
            <li>Readability</li>
            <li>Sentences</li>
          </ul>
          <p>
            It's free and you can use it for an unlimited time. It helps you
            find the drawbacks of your content.
          </p>

          <h2>SeoBix: Your Undetectable AI Humanizer That Works</h2>
          <p>
            Stop wasting time editing clunky AI drafts. Let SeoBix humanize your
            AI text and turn it into something that actually sounds like you
            wrote it.
          </p>
          <p>
            With SeoBix’s undetectable AI humanizer, your writing becomes clear,
            smooth, and hard to flag by detectors. You write fast with AI —
            SeoBix makes it feel real.
          </p>
          <h2>FAQs</h2>
          <ol>
            <li>
              <strong>What does SeoBix's AI humanizer do?</strong>
              <br />
              It rewrites all AI-generated content to sound more human, natural,
              and makes it hard to detect by AI tools.
            </li>
            <li>
              <strong>Can SeoBix help me bypass AI detection tools?</strong>
              <br />
              Yes. SeoBix Content Humanizer helps you bypass many AI tools like
              ZeroGpt, QuillBot, and Turnitin.
            </li>
            <li>
              <strong>Is SeoBix’s AI humanizer free?</strong>
              <br />
              Yes, it is a 100% free AI text humanizer — no login or credit card
              needed.
            </li>
            <li>
              <strong>Will it change the meaning of my content?</strong>
              <br />
              No. SeoBix keeps your original message intact while improving the
              tone and flow of the content.
            </li>
            <li>
              <strong>Is my content safe on SeoBix?</strong>
              <br />
              Yes, absolutely. SeoBix doesn’t store or track your content —
              everything is private and processed instantly.
            </li>
          </ol>

          <div className="d-flex justify-content-center mt-4">
            <Button
              onClick={() => setShowMore(false)}
              style={{
                padding: "6px 20px",
                backgroundColor: "#fff",
                color: "#dc3545",
                fontWeight: "600",
                fontSize: "0.95rem",
                border: "2px solid #dc3545",
                borderRadius: "999px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#dc3545";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.color = "#dc3545";
              }}
            >
              Hide
            </Button>
          </div>
        </>
      )}
      <Plancard />
      <Trialcards />
      <Related />
      <TestimonialPage />
      <Specialoffer />
      <BackLinkCards />
      <Plancard />
    </div>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2
        className="text-center m-4"
        style={{ fontWeight: "700", fontSize: "2rem" }}
      >
        What Includes In All Plans ?
      </h2>
      <div className="row m-0 p-0">
        {cardsData.map((card, index) => (
          <div key={index} className="col-12 col-md-4 p-2 d-flex">
            <div className="card w-100 h-100 p-2">
              <div className="d-flex h-100">
                <div
                  style={{ flex: 1 }}
                  className="d-flex flex-column position-relative"
                >
                  <div>
                    <img
                      src={card.keyImg}
                      alt={card.title}
                      style={{
                        height: "5vh",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                      }}
                    />
                    <h5>{card.title}</h5>
                  </div>
                </div>

                <div
                  style={{ flex: 1 }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={card.coreImg}
                    alt={card.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Related = () => {
  const { siteurl, siteid } = useContext(GlobalContext);
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const domainTypeOptions = [
    { value: "domain", label: "Domain" },
    { value: "subdomain", label: "Subdomain" },
  ];

  const regionOptions = [
    { value: "en-US", label: "United States (en-US)" },
    { value: "en-GB", label: "United Kingdom (en-GB)" },
    { value: "en-CA", label: "Canada (English) (en-CA)" },
    { value: "en-AU", label: "Australia (en-AU)" },
  ];

  const [formData, setFormData] = useState({
    domainInput: siteurl,
    domainType: domainTypeOptions[0],
    region: regionOptions[0],
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const [rankingKeywords, setRankingKeywords] = useState([]);
  const [queary, setqueary] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  const DomainRankingKeywords = async (type) => {
    try {
      const uuid = generateUUID();
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/DomainRankingKeywords`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uuid: uuid,
            url: formData.domainInput,
            scope: formData.domainType?.value,
            locale: formData.region?.value,
            type: type,
          }),
        }
      );
      const data = await res.json();

      if (data.status === "0" && data.data) {
        const rankingData = data.data.map((item) => ({
          keyword: item.keyword,
          url: item.url,
          ranking_page: item.ranking_page,
          rank_position: item.rank_position,
          difficulty: item.difficulty,
          volume: item.volume,
        }));

        setRankingKeywords(rankingData);
        setqueary({ query: data.data[0].url });
        processChartData(rankingData);
        setShowResults(true);
      } else {
        setShowResults(false);
      }
    } catch (error) {
      console.log("error", error);
      setShowResults(false);
    }
  };

  const processChartData = (keywords) => {
    const ranges = {
      "1-3": 0,
      "4-10": 0,
      "11-20": 0,
      "21-30": 0,
      "31-40": 0,
      "41-50": 0,
    };
    keywords.forEach((keyword) => {
      const position = keyword.rank_position;
      if (position >= 1 && position <= 3) ranges["1-3"]++;
      else if (position >= 4 && position <= 10) ranges["4-10"]++;
      else if (position >= 11 && position <= 20) ranges["11-20"]++;
      else if (position >= 21 && position <= 30) ranges["21-30"]++;
      else if (position >= 31 && position <= 40) ranges["31-40"]++;
      else if (position >= 41 && position <= 50) ranges["41-50"]++;
    });

    setChartData([
      { range: "#1-3", count: ranges["1-3"] },
      { range: "#4-10", count: ranges["4-10"] },
      { range: "#11-20", count: ranges["11-20"] },
      { range: "#21-30", count: ranges["21-30"] },
      { range: "#31-40", count: ranges["31-40"] },
      { range: "#41-50", count: ranges["41-50"] },
    ]);
  };

  const countKeywordsInRankRange = (keywords, start, end) => {
    return keywords.filter(
      (keyword) =>
        keyword.rank_position >= start && keyword.rank_position <= end
    ).length;
  };

  const range1to3 = countKeywordsInRankRange(rankingKeywords, 1, 3);
  const range4to10 = countKeywordsInRankRange(rankingKeywords, 4, 10);
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/bix-keyword-analyzer");
  };
  const [hasLoaded, setHasLoaded] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setHasLoaded(true);
    }, 500);
  }, []);

  return (
    <div className="mt-5 mb-5">
      <div
        // onClick={handleClick}
        style={{
          cursor: "pointer",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background: "linear-gradient(to right, #EDE7F6, #E3F2FD)",
            borderRadius: "12px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.01)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Col md={10} className="p-3">
            <h3 className="text-center">
              <b>Find Your Domain's Ranking Keywords Instantly</b>
            </h3>
            <p className="text-center">
              See which keywords your website currently ranks for in search
              engines. Analyze performance, uncover SEO opportunities, and boost
              your visibility.
            </p>

            <Row className=" align-items-center rounded m-3">
              <Col md={6}>
                <Form.Control
                  type="text"
                  placeholder="Enter a domain, subdomain, or exact page"
                  value={formData.domainInput}
                  onChange={(e) => handleChange("domainInput", e.target.value)}
                />
              </Col>

              <Col md={4} className="d-flex align-items-center p-0">
                <Form.Select
                  className="mx-2"
                  value={formData.domainType.value}
                  onChange={(e) =>
                    handleChange(
                      "domainType",
                      domainTypeOptions.find(
                        (opt) => opt.value === e.target.value
                      )
                    )
                  }
                >
                  {domainTypeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>

                <Form.Select
                  value={formData.region.value}
                  onChange={(e) =>
                    handleChange(
                      "region",
                      regionOptions.find((opt) => opt.value === e.target.value)
                    )
                  }
                >
                  {regionOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col md={2} className="d-flex justify-content-center">
                <Button
                  size="sm"
                  style={{ background: "#441752", color: "#fff" }}
                  onClick={() => DomainRankingKeywords("1")}
                >
                  Analyze
                </Button>
              </Col>
            </Row>

            {showResults && (
              <>
                {" "}
                <Row className="p-0 m-2">
                  <Card
                    className="p-2 m-2 col"
                    style={{
                      background: "#E3F2FD",
                      border: "1px solid #90CAF9",
                    }}
                  >
                    <div className="row p-0 m-0">
                      <div className="col justify-content-center text-center">
                        <h6>Site</h6>
                        <hr className="m-1 p-0" />
                        <h5>{queary?.query}</h5>
                      </div>
                      <div className="col justify-content-center text-center">
                        <h6>Ranking Keyword</h6>
                        <hr className="m-1 p-0" />
                        <h4>{rankingKeywords?.length}</h4>
                      </div>
                    </div>
                  </Card>

                  <Card
                    className="p-2 m-2 col"
                    style={{
                      background: "#FFF3E0",
                      border: "1px solid #FFB74D",
                    }}
                  >
                    <div>
                      <h6>Top Position Keywords</h6>
                      <hr className="m-1 p-0" />
                      <Row className="m-0 p-0">
                        <Col>
                          <p className="mb-0"># 1-3</p>
                        </Col>
                        <Col>
                          <p className="mb-0">{range1to3} Keywords</p>
                        </Col>
                      </Row>
                      <Row className="m-0 p-0">
                        <Col>
                          <p className="mb-0"># 4-10</p>
                        </Col>
                        <Col>
                          <p className="mb-0">{range4to10} Keywords</p>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Row>
                <div className="table-container m-3">
                  <table
                    className="table table-bordered w-100 mt-3"
                    style={{
                      backgroundColor: "#F3E5F5",
                      borderBottom: "2px solid #6A1B9A",
                      color: "#4A148C",
                    }}
                  >
                    <thead style={{ backgroundColor: "#CE93D8" }}>
                      <tr>
                        <th>Keyword</th>
                        <th>
                          Domain<h6>{queary?.query}</h6>
                        </th>
                        <th>Difficulty</th>
                        <th>Monthly Volume</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rankingKeywords
                        ?.slice(0, 5)
                        ?.map((keywordData, index) => {
                          const isBlurred = index >= 3;

                          return (
                            <tr
                              key={index}
                              style={{
                                filter: isBlurred ? "blur(4px)" : "none",
                                pointerEvents: isBlurred ? "none" : "auto",
                                transition: "filter 0.3s ease",
                              }}
                            >
                              <td>{keywordData?.keyword}</td>
                              <td>
                                #{keywordData?.rank_position}
                                <br />
                                <p className="mb-0">
                                  {keywordData?.ranking_page}
                                </p>
                              </td>
                              <td>{keywordData?.difficulty}</td>
                              <td>{keywordData?.volume}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={4} className="text-center">
                          <button
                            onClick={handleClick}
                            style={{
                              marginTop: "10px",
                              padding: "6px 16px",
                              borderRadius: "999px",
                              backgroundColor: "#0d6efd",
                              color: "#fff",
                              border: "none",
                              fontWeight: "600",
                              fontSize: "0.95rem",
                              cursor: "pointer",
                            }}
                          >
                            View Full Report
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>{" "}
              </>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};
const cardData = [
  {
    title: "Content Quality Checker",
    description:
      "Instantly check your content for grammar, readability, keyword usage, and SEO structure. Get clear, actionable feedback to improve your writing in seconds.",
    linkText: "Check Content Quality",
    linkUrl: "/content-quality-checker",
    bgColor: "#f4f7fb",
  },
  {
    title: "Humanizer Tool",
    description:
      "Convert robotic AI-generated text into human-like, natural writing. Bypass AI detectors and make your content feel more authentic.",
    linkText: "Use Humanizer",
    linkUrl: "/ai-humanizer-tool",
    bgColor: "#dff5ff",
  },
  {
    title: "Bix content generator",
    description:
      "Generate high-quality blog posts, product descriptions, intros, and more from a single keyword. Smart, fast, and human-sounding.",
    linkText: "Start Generating",
    linkUrl: "/bix-content-generator",
    bgColor: "#f4f7fb",
  },
  {
    title: "DA/PA Checker",
    description:
      "Evaluate domain authority and page authority instantly. Understand your SEO strength and compare with competitors in real-time.",
    linkText: "Check DA/PA",
    linkUrl: "/da-pa-checker",
    bgColor: "#d6ffd6",
  },
];
const BackLinkCards = () => {
  return (
    <div style={{ overflow: "hidden", padding: "20px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Content Optimization Toolkit: Everything You Need
          </h2>
        </div>
        <div className="row justify-content-center g-4">
          {cardData.map((card, index) => (
            <div key={index} className="col-md-6 col-lg-3 p-1">
              <div
                style={{
                  backgroundColor: card.bgColor,
                  padding: "24px",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text-muted" style={{ fontSize: "15px" }}>
                    {card.description}
                  </p>
                </div>
                <div>
                  <a
                    href={card.linkUrl}
                    className="text-primary fw-semibold"
                    style={{ textDecoration: "none" }}
                  >
                    {card.linkText} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
const GaugeCard = ({ title, value, max, color }) => {
  const percentage = Math.min((value / max) * 100, 100);
  const radius = 60;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div
      className="p-2 bg-white rounded border text-center"
      style={{
        boxShadow:
          "0 4px 8px rgba(0, 0, 0, 0.15), 0 6px 20px rgba(0, 0, 0, 0.1)",
        width: 200,
        margin: "auto",
      }}
    >
      <h6 className="m-0 mb-2">{title}</h6>

      <div
        style={{
          position: "relative",
          width: "100%",
          height: 100,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <svg width="140" height="80">
          <circle
            cx="70"
            cy="70"
            r={radius}
            fill="transparent"
            stroke="#eee"
            strokeWidth="12"
            strokeDasharray={circumference}
            strokeDashoffset={0}
            transform="rotate(-90 70 70)"
          />
          <circle
            cx="70"
            cy="70"
            r={radius}
            fill="transparent"
            stroke={color}
            strokeWidth="12"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 70 70)"
          />
        </svg>

        <div
          style={{
            position: "absolute",
            top: "60%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "1.4rem",
            fontWeight: "bold",
            color: "#000",
          }}
        >
          {value}
        </div>
      </div>
    </div>
  );
};
export default Humanizer;
